<template>
    <div>
        <el-form :model="planDto" ref="voucherInfo" class="demo-ruleForm">
            <div class="content-caption dashed">
                <span>基础信息</span>
            </div>
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">标题</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="title" :rules="{validator: checkTitle, trigger: 'blur'}">
                            <el-input class="width-2x" type="text" v-model="planDto.title" placeholder="请输入标题"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">合同</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="contractNo" :rules="{validator: checkNull, trigger: 'blur'}">
                            <el-input class="width-1-5x bottom-line" :disabled="true" v-model="planDto.contractNo"></el-input>
                            <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" @click="selectContract()"></i>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>服务商</label>
                    </div>
                    <div class="form-value">
                        <span>{{planDto.servicerName}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">服务内容</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="servcSpecs" :rules="{validator: checkNull, trigger: 'blur'}">
                            <el-input class="width-1-5x bottom-line" :disabled="true" v-model="planDto.servcSpecs"></el-input>
                            <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" @click="selectContractServc()"></i>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>维保分组</label>
                    </div>
                    <div class="form-value width-2x">
                        <span>{{ planDto.devcGroupNames }}</span>
                    </div>
                </div>
            </div>
            <div class="content-caption dashed">
                <span>保养机构</span>
                <a class="swb-btn swb-btn-small" @click="showAppliedShopDlg">选择机构</a>

                <a class="swb-btn swb-btn-small fr" @click="setYqInfo">批量设置</a>
            </div>
            <div class="table-layout custom-tbl error-prompt">
                <el-table :data="planDto.comList" border style="width: 100%" @selection-change="handleSelectionChange" tooltip-effect="dark">
                    <el-table-column type="selection" width="55" align="center"></el-table-column>
                    <el-table-column prop="shopName" label="机构名称" align="left"></el-table-column>
                    <el-table-column prop="cronFlag" label="周期保养" align="center" width="80">
                        <template slot-scope="rows">
                            <el-checkbox v-model="rows.row.cronFlag" @change="checkInfo(rows.$index)"></el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column prop="theDateTime" label="保养时间" align="center" width="200">
                        <template slot-scope="rows">
                            <el-form-item :prop="'comList.' + rows.$index + '.theDateTime'" :rules="{validator: checkTheDateTime, trigger: 'change'}">
                                <div v-if="rows.row.cronFlag">
                                    <span>{{rows.row.theExprDesc || ''}}</span>
                                    <a class="swb-btn-link" @click="selectCronInfo(rows.$index)">选择周期</a>
                                </div>
                                <div v-else>
                                    <el-date-picker style="width: auto" v-model="rows.row.theDateTime" type="datetime" :picker-options="pickerOptions0" placeholder="选择日期时间" format="yyyy-MM-dd HH:mm"></el-date-picker>
                                </div>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column prop="limitEndTime" label="保养截止时间" align="center" width="200">
                        <template slot-scope="rows">
                            <span v-if="rows.row.cronFlag">{{rows.row.limitEndTime || "无"}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="yqFinishTime" label="工单截止时间" align="center" width="200">
                        <template slot-scope="rows">
                            <el-form-item :prop="'comList.' + rows.$index + '.yqFinishTime'" :rules="{validator: ((rule, value, callback)=>{checkYqFinishTime(rule, value, callback, rows.$index)}), trigger: 'change'}">
                                <el-date-picker style="width: auto" v-model="rows.row.yqFinishTime" :picker-options="pickerOptions0" type="datetime" placeholder="请选择" @change="yqFinishTimeChange(rows.$index)"></el-date-picker>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column prop="yqFinishHours" label="要求完成小时" align="center" width="100"></el-table-column>
                    <el-table-column prop="yqFinishAotHr" label="提前预警小时" align="center" width="100">
                        <template slot-scope="rows">
                            <el-form-item :prop="'comList.' + rows.$index + '.yqFinishAotHr'" :rules="{validator: inputYqFinishAotHr, trigger: 'blur'}">
                                <el-input type="number" min="0" class="input-content-right" v-model.number="rows.row.yqFinishAotHr"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="left" width="80">
                        <template slot-scope="rows">
                            <a class="swb-btn-link" @click="removeItem(rows.$index)">移除</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-form>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import { openCronEditorDlg } from '../cron/selectDlg'
    import { openContractListForSelectDlg, openContractServcListForSelectDlg } from '../contract/dialog'
    import { openRetailerComListForSelectDlg } from '../retailer/selectDlg'
    import { setPlanYqInfoForBatchDlg } from './dialog'
    //
    import contractApi from '../../api/contract'
    import comnApi from '../../api/comn'
    //
    export default {
        name: 'swb-device-maint-plan-for-oneServicer-add-batch',
        desc: '新增机构资产保养',
        data: function () {
            return {
                planDto: {
                    title: null,
                    contractId: null,
                    contractNo: null,
                    servicerId: null,
                    servicerName: null,
                    servcSpecs: null,
                    devcGroupId: null,
                    devcGroupNames: null,
                    comList: []
                },
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7 || time.format('yyyy') >= new Date('2038-01-19').format('yyyy');
                    }
                },
                selRows: []
            }
        },
        created: function () {
        },
        methods: {
            checkNull: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            },
            checkTitle: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else if(value.length > 14) {
                    callback(new Error('最长14个字符'));
                } else {
                    callback();
                }
            },
            // 保存设备保养计划
            getDlgResult: function () {
                let self = this;
                let result = null;
                this.$refs['voucherInfo'].validate(function (valid) {
                    result = {};
                    if(valid) {
                        let planDto = self.planDto;
                        let comList = planDto.comList;
                        if(planDto.devcGroupId.length > 10) {
                            result.type = 'warn';
                            result.message = '服务内容最多选择10个';
                        } else if(comList.length == 0) {
                            result.type = 'warn';
                            result.message = '请选择保养机构';
                        } else {
                            let message = null;
                            for(let i = 0; i < comList.length; i++) {
                                if(!Utils.isNoB(comList[i].yqFinishAotHr) && Utils.isNoB(comList[i].yqFinishTime)) {
                                    message = comList[i].shopName + '已设置提前预警小时，请设置工单截止时间';
                                    break;
                                }
                            }
                            if(message == null) {
                                result.type = 'info';
                                result.data = planDto;
                            } else {
                                result.type = 'warn';
                                result.message = message;
                            }
                        }
                    } else {
                        result.type = 'warn';
                        result.message = "校验失败！";
                    }
                });
                return result;
            },
            selectContract(){
                let self = this;
                let filterItems = {
                    curValid: true,
                    confirmed: true,
                    fullfilled: false,
                    closed: false,
                    terminated: false,
                    offline: false,
                    lockModes: [0, 1],
                    typeIds: [2, 3],
                    realComIdIsNull: true
                };
                openContractListForSelectDlg(filterItems, function (contract) {
                    if(!Utils.isNoB(contract)) {
                        let planDto = self.planDto;
                        planDto.contractId = contract.id;
                        planDto.contractNo = contract.no;
                        planDto.contractOriginalNo = contract.originalNo;
                        planDto.servicerId = contract.sndPartyId;
                        planDto.servicerName = contract.sndPartyName;
                        //
                        planDto.devcGroupId = null
                        planDto.devcGroupNames = null;
                        planDto.servcSpecIds = null;
                        planDto.servcSpecs = null;
                        //
                        self.planDto = Utils.merge({}, planDto);
                    }
                });
            },
            selectContractServc(){
                let self = this;
                let planDto = this.planDto;
                if(planDto.contractId == null) {
                    MsgBox.warning('请选择合同');
                    return;
                }
                openContractServcListForSelectDlg({
                    params: {
                        contractId: planDto.contractId,
                        servcTypeId: 1
                    }
                }, function (servcList, theDlg) {
                    let devcGroupIds = [];
                    for(let i = 0; i < servcList.length; i++) {
                        if(devcGroupIds.indexOf(servcList[i].devcGroupId) == -1) {
                            devcGroupIds.push(servcList[i].devcGroupId);
                        } else {
                            MsgBox.warning('维保分组不可重复选择，【' + servcList[i].devcGroupFullName + '】重复');
                            return;
                        }
                    }
                    planDto.devcGroupId = devcGroupIds;
                    //
                    let devcGroupFullNameList = servcList.pluck('devcGroupFullName');
                    planDto.devcGroupNames = devcGroupFullNameList.join(',');
                    //
                    let servcSpecIdList = servcList.pluck('id');
                    planDto.servcSpecIds = servcSpecIdList.join(',');
                    //
                    let servcSpecList = servcList.pluck('servcSpec');
                    planDto.servcSpecs = servcSpecList.join(',');
                    //
                    self.planDto = Utils.merge({}, planDto);
                    theDlg.close();
                });
            },
            getAppliedShopIds(contractOriginalNo, callback){
                let self = this;
                let theLoading = MsgBox.loading();
                contractApi.getContractAppliedShopIds({
                    contractOriginalNoX: contractOriginalNo
                }, function (result) {
                    theLoading.close();
                    if(result.type === "info") {
                        callback(result.data);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            showAppliedShopDlg(){
                let self = this;
                let planDto = this.planDto;
                if(planDto.contractId == null) {
                    MsgBox.warning('请选择合同');
                    return;
                }
                let disabledIds = planDto.comList.pluck('shopId');
                this.getAppliedShopIds(planDto.contractOriginalNo, function (selectedShopIds) {
                    if(selectedShopIds.length == 0){
                        selectedShopIds.push(-1);
                    }
                    let queryFilter = {
                        ids: selectedShopIds,
                        disabledIds: disabledIds,
                        orgType: 1,
                        states: [1]
                    };
                    openRetailerComListForSelectDlg(queryFilter, function (resultData, theDlg) {
                        theDlg.close();
                        let comList = planDto.comList;
                        resultData.forEach(function (item) {
                            comList.push({
                                shopId: item.id,
                                shopName: item.name,
                                shopNo: item.no
                            });
                        });
                        planDto.comList = comList;
                        self.planDto = Utils.merge({}, planDto);
                    });
                });
            },
            removeItem(index){
                let planDto = this.planDto;
                planDto.comList.removeAt(index);
                this.planDto = Utils.merge({}, planDto);
            },
            // 选择周期
            selectCronInfo: function (index) {
                let self = this;
                let planDto = this.planDto;
                let comList = planDto.comList;
                let deviceMaintPlan = comList[index];
                let params = {};
                params.cronJson = deviceMaintPlan.theDataJson || {};
                params.cronSecondNeeded = false;
                params.timeLimit = {};
                //
                let dataExType = deviceMaintPlan.dataExType;
                let timeLimit = {};
                timeLimit.limitType = dataExType;
                if(dataExType == 2) {   // 限制时间
                    timeLimit.limitTimed = deviceMaintPlan.limitEndTime;
                } else {
                    timeLimit.limitTimed = null;
                }
                params.timeLimit = timeLimit;
                //
                // params.fixedYear = false;
                params.fixedYear = false;
                params.fixedYearType = false;
                openCronEditorDlg(params, function (jsonResult) {
                    self.getTheDateTime(jsonResult.data, function (theDateTime) {
                        deviceMaintPlan.theDateTime = new Date(theDateTime);
                        deviceMaintPlan.theDataJson = jsonResult.data;
                        deviceMaintPlan.theData = JSON.encode(jsonResult.data);
                        deviceMaintPlan.theExprDesc = jsonResult.dataDesc;
                        //
                        let dataEx = jsonResult.dataEx;
                        if(!Utils.isNoB(dataEx)) {
                            deviceMaintPlan.dataExType = dataEx.limitType;
                            if(dataEx.limitType == 0) { // 无限制
                                deviceMaintPlan.limitEndTime = null;
                            } else if(dataEx.limitType == 2) {  // 限制时间
                                deviceMaintPlan.limitEndTime = dataEx.limitTimed || null;
                            }
                        } else {
                            // 不支持-截止时间
                        }
                        planDto.comList = comList;
                        self.planDto = Utils.merge({}, planDto);
                    });
                });
            },
            getTheDateTime: function (theDataJson, callback) {
                let postData = {
                    theData: JSON.encode(theDataJson)
                };
                comnApi.getNextExecutionTime(postData, function (result) {
                    if(result.type == 'info') {
                        callback(result.data);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            checkInfo(index){
                let planDto = this.planDto;
                let comList = planDto.comList;
                let deviceMaintPlan = comList[index];
                deviceMaintPlan.theDateTime = null;
                deviceMaintPlan.theExprDesc = null;
                deviceMaintPlan.theDataJson = null;
                deviceMaintPlan.theData = null;
                deviceMaintPlan.yqFinishTime = null;
                deviceMaintPlan.yqFinishHours = null;
                planDto.comList = comList;
                this.planDto = Utils.merge({}, planDto);
            },
            yqFinishTimeChange(index){
                let planDto = this.planDto;
                let comList = planDto.comList;
                let deviceMaintPlan = comList[index];
                if(Utils.isNoB(deviceMaintPlan.theDateTime)) {
                    deviceMaintPlan.yqFinishTime = null;
                    MsgBox.warning('请先设置保养时间');
                    return;
                }
                if(Utils.isTrue(deviceMaintPlan.cronFlag)) {
                    let times = deviceMaintPlan.yqFinishTime.getTime() - deviceMaintPlan.theDateTime.getTime();
                    let hours = Math.round(times / (3600 * 1000));
                    deviceMaintPlan.yqFinishHours = Utils.merge(null, hours);
                }
                planDto.comList = comList;
                this.planDto = Utils.merge({}, planDto);
            },
            // 预警小时校验
            inputYqFinishAotHr: function (rule, value, callback) {
                if(!Utils.isNoB(value) && value <= 0) {
                    callback(new Error('预警小时应为正整数！'));
                } else {
                    callback();
                }
            },
            // 多选
            handleSelectionChange: function (selRows) {
                this.selRows = selRows;
            },
            checkTheDateTime: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    if(new Date() >= value) {
                        callback(new Error('保养时间需大于当前时间'));
                    } else {
                        callback();
                    }
                }
            },
            checkYqFinishTime(rule, value, callback, index){
                if(Utils.isNoB(value)) {
                    if(!Utils.isNoB(this.planDto.comList[index].yqFinishAotHr)) {
                        callback(new Error('已设置提前预警小时,请设置工单截止时间'));
                    } else {
                        callback();
                    }
                } else {
                    if(!Utils.isNoB(this.planDto.comList[index].theDateTime) && value < this.planDto.comList[index].theDateTime) {
                        callback(new Error('工单截止时间要晚于首次保养时间:' + this.planDto.comList[index].theDateTime.format("yyyy-MM-dd")));
                    } else {
                        callback();
                    }
                }
            },
            setYqInfo(){
                let self = this;
                let selRows = this.selRows;
                if(selRows.length == 0) {
                    this.$message.warning('请选择要设置的机构');
                    return;
                }
                let planDto = this.planDto;
                let comList = planDto.comList;
                let params = {
                    planType: "保养"
                };
                setPlanYqInfoForBatchDlg(params, function (result) {
                    for(let i = 0; i < selRows.length; i++) {
                        let deviceSubNo = selRows[i];
                        deviceSubNo.cronFlag = result.cronFlag;
                        deviceSubNo.theDateTime = result.theDateTime;
                        deviceSubNo.theDataJson = result.theDataJson;
                        deviceSubNo.theData = result.theData;
                        deviceSubNo.theExprDesc = result.theExprDesc;
                        deviceSubNo.limitEndTime = result.limitEndTime;
                        //
                        deviceSubNo.yqFinishTime = result.yqFinishTime;
                        deviceSubNo.yqFinishAotHr = result.yqFinishAotHr;
                        deviceSubNo.yqFinishHours = result.yqFinishHours;
                    }
                    self.planDto = Utils.merge({}, planDto);
                });
            }
        }
    }

</script>
<style>
    .form-value .el-form-item .el-form-item--small {
        margin-bottom: 0;
        margin-top: 4px;
    }
</style>



// WEBPACK FOOTER //
// src/compo/retailer/DeviceMaintPlanOnServicerAddBatch.vue